import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import Testimonial from "./Testimonial";
import { IOffer } from "./Types";
import { Button, Popover, OverlayTrigger } from "react-bootstrap";

function HowWeCompare(props: { offer: IOffer }) {
    const history = useHistory();
    const location = useLocation();

    const routeToOfferPage = () => {
        window.addToDataLayer({ event: "dtcSalesLandingSignMeUp" });
        let offerPagePath = "/sales_landing/step2" + location.search;
        history.push(offerPagePath, { from: 'saleslanding page' } );
    };

    const PopoverWithContent = (title: string, content: string) => (
        <Popover id="popover-basic" className="sales-landing" style={{ marginLeft: "8px" }}>
            <Popover.Title as="h4" className="popover-title">
                {title}
            </Popover.Title>
            <Popover.Content className="popover-content">{content}</Popover.Content>
        </Popover>
    );

    const PopoverTrigger = (title: string, content: string) => {
        return (
            <OverlayTrigger trigger="click" rootClose placement="right" overlay={PopoverWithContent(title, content)}>
                <span
                    className="info-ico compare-plus"
                    onClick={() => {
                        window.addToDataLayer({ event: "dtcSalesLandingToolTipServiceDetails" });
                    }}
                >
                    +
                </span>
            </OverlayTrigger>
        );
    };

    return (
        <>
            <div id="how-we-compare-section" style={{ backgroundColor: "#ffffff" }}>
                <div id="compare" className="container compare">
                    <div className="row">
                        <div className="col-sm-10 col-12 offset-sm-1">
                            <table className="table table-condensed compare-table">
                                <tbody>
                                    <tr>
                                        <td style={{ border: "0px solid transparent" }}></td>
                                        <td className="logo-td compare-column-idf" style={{ paddingTop: "30px !important" }}>
                                            <img role="option"
                                                style={{ maxWidth: "100%" }}
                                                className="compet-logo identity-force-compet img-fluid"
                                                src={require("../../Assets/images/funnel/sales/if-logo-horizontal.png").default}
                                                alt="IdentityForce"
                                            />
                                        </td>
                                        <td className="logo-td" style={{ paddingTop: "30px !important" }}>
                                            <img role="option"
                                                style={{ maxWidth: "150px" }}
                                                className="compet-logo identity-guard-compet img-fluid"
                                                src={require("../../Assets/images/funnel/sales/IdentityGuard-logo.png").default}
                                                alt="Identity Guard"
                                            />
                                        </td>
                                        <td className="logo-td" style={{ paddingTop: "30px !important" }}>
                                            <img role="option"
                                                style={{ maxWidth: "150px" }}
                                                className="compet-logo life-lock-compet img-fluid"
                                                src={require("../../Assets/images/funnel/sales/LifeLock-logo.png").default}
                                                alt="Lifelock"
                                            />
                                        </td>
                                    </tr>

                                    <tr className="subheader-row">
                                        <td style={{ border: "0px solid transparent" }}></td>
                                        <td className="compare-column-idf subheader" style={{ border: "0px solid transparent" }}>
                                            UltraSecure
                                            <wbr />
                                            +Credit
                                        </td>
                                        <td className="subheader" style={{ border: "0px solid transparent" }}>
                                            Ultra
                                        </td>
                                        <td className="subheader" style={{ border: "0px solid transparent" }}>
                                            Ultimate <wbr />
                                            Plus
                                        </td>
                                    </tr>

                                    <tr className="no-border">
                                        <td className="text-left"></td>
                                        <td className="compare-column-idf" style={{ paddingTop: "30px !important", paddingBottom: "30px !important" }}>
                                            <p>
                                                <button className="btn-default btn-primary sign-me-up" onClick={routeToOfferPage} type="button">
                                                    <span>SIGN ME UP</span>
                                                </button>
                                            </p>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <th className="text-left">
                                            <h4>
                                                <img role="option"
                                                    className="img-icon"
                                                    src={require("../../Assets/images/funnel/sales/monitor-white-icon.png").default}
                                                    alt="Monitor Icor"
                                                />
                                                Monitor
                                            </h4>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>

                                    <tr>
                                        <td className="text-left">
                                            Advanced Fraud Monitoring
                                            {PopoverTrigger(
                                                "Advanced Fraud Monitoring",
                                                "Delivers virtually real-time, proactive alerts when lenders, such as banks, auto dealers, mortgage companies and government agencies, request a copy of your credit report. Early notification helps you stop fraudulent attempts to open a new account or increase a line of credit. Any credit activity can hurt your credit score."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Change of Address Monitoring
                                            {PopoverTrigger(
                                                "Change of Address Monitoring",
                                                "Monitors and alerts you if your mail has been redirected through USPS without your authorization. When criminals commit fraud they typically change the physical address to gain access to mail, bills, credit card statements and other financial documents."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Court Records Monitoring
                                            {PopoverTrigger(
                                                "Court Records Monitoring",
                                                "Continuously search millions of criminal and court records to determine if your identity has been used by any unauthorized individuals."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Dark Web Monitoring
                                            {PopoverTrigger(
                                                "Dark Web Monitoring",
                                                "Continuously scours thousands of websites, chat rooms, blogs and other data sources to detect illegal trading and selling of your personal information. Scans for your personal information including social security number, driver's license, mother's maiden name, phone number, email addresses, bank account and routing numbers, credit and debit card numbers and medical identification numbers."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Dark Web Data Analysis
                                            {PopoverTrigger(
                                                "Dark Web Data Analysis",
                                                "An in-depth, algorithm-based process that crawls and accesses the dark web and locates breached personal information. Combines human research and investigative methods to analyze potentially exposed information and determine an accurate risk level of having your identity compromised."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Pay Day Loan Monitoring
                                            {PopoverTrigger(
                                                "Pay Day Loan Monitoring",
                                                "Immediately alert you to any payday or quick cash loans that were obtained using your social security number."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Sex Offender Monitoring
                                            {PopoverTrigger(
                                                "Sex Offender Monitoring",
                                                "In-depth search of sex offender registries to determine if a sex offender fraudulently used your personal data as their registration information. Alerts you if registered sex offenders are living in your neighborhood or move into your neighborhood."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Social Media Identity Monitoring
                                            {PopoverTrigger(
                                                "Social Media Identity Monitoring",
                                                "Monitor your Facebook, X, YouTube, Google+, and Instagram accounts for inappropriate activity and posts that could be perceived as violent, are using profanity, or could be categorized as cyberbullying or discriminatory."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Mobile Threat Protection
                                            {PopoverTrigger(
                                                "Mobile Threat Protection",
                                                "Mobile Attack Control™, which monitors and alerts IdentityForce Mobile App users to a wide array of threats including rogue apps, spyware, unsecured Wi-Fi connections, and even recognizes fake or “spoof” networks."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Secure VPN
                                            {PopoverTrigger(
                                                "Secure VPN",
                                                "Access a Virtual Private Network (VPN) through IdentityForce's mobile app, providing a secure internet connection anywhere you go."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>

                                    <tr className="hidden-sm no-border">
                                        <td></td>
                                        <td className="compare-column-idf"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th className="text-left">
                                            <h4>
                                                <img role="option"
                                                    className="img-icon"
                                                    src={require("../../Assets/images/funnel/sales/alert-white-icon.png").default}
                                                    alt="Alert Icon"
                                                />
                                                Alert
                                            </h4>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Bank and Credit Card Activity Alerts
                                            {PopoverTrigger(
                                                "Bank and Credit Card Activity Alerts",
                                                "Receive email and mobile text alerts when a charge, withdrawal or balance transfer exceeds a dollar amount determined by you. Help quickly spot credit card fraud and bank account fraud in one centralized place."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Smart SSN Tracker
                                            {PopoverTrigger(
                                                "Smart SSN Tracker",
                                                "Secure Social Security Number tracking that intelligently alerts you if there's an unfamiliar name, alias, or address associated with your SSN, which could be an indication of fraud. As a result, greatly reduces the time, money, and emotional stress associated with stolen SSN."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>Limited</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Junk Mail Opt-Out
                                            {PopoverTrigger(
                                                "Junk Mail Opt-Out",
                                                "Stop thieves from snatching your personal information out of your mailbox or trash. Removes your name from the most frequently used marketing databases and stops pre-approved credit card offers."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Identity Threat Alerts
                                            {PopoverTrigger(
                                                "Identity Threat Alerts",
                                                "Get alerts when your personal information is at increased risk due to data breaches."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Fraud Alert Reminders
                                            {PopoverTrigger(
                                                "Fraud Alert Reminders",
                                                "Help place fraud alerts on your credit file if your identity is at risk to prevent identity thieves from opening new lines of credit in your name."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Investment Account Alerts
                                            {PopoverTrigger("Investment Account Alerts", "Alerts and monitors activity in investment accounts.")}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>

                                    <tr className="hidden-sm no-border">
                                        <td></td>
                                        <td className="compare-column-idf"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th className="text-left">
                                            <h4>
                                                <img role="option"
                                                    className="img-icon"
                                                    src={require("../../Assets/images/funnel/sales/control-white-icon.png").default}
                                                    alt="Control Icon"
                                                />
                                                Control
                                            </h4>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Medical ID Fraud Protection
                                            {PopoverTrigger(
                                                "Medical ID Fraud Protection",
                                                "Helps review your medical benefits statements to ensure that you and your family are the only ones using your medical benefits."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Online PC Protection Tools
                                            {PopoverTrigger(
                                                "Online PC Protection Tools",
                                                "Anti-phishing and anti-keylogging software protect you while shopping, banking and sharing online from your PC. Proactively prevents malware from stealing sensitive data such as your username, password, credit card number, bank account details or other sensitive data that you type on your PC keyboard. Protects every keystroke as you enter it, and detects dangerous fake sites to prevent phishing attacks."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Two-Factor Authentication
                                            {PopoverTrigger(
                                                "Two-Factor Authentication",
                                                "Although it sounds technical, two-step verification — Also called Two-Factor authentication, or 2FA — is very simple. Instead of the usual Login involving only a User ID and Password, Members will receive a second form of authentication — a verification code — delivered by email, text, or phone."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Lost Wallet Assistance
                                            {PopoverTrigger(
                                                "Lost Wallet Assistance",
                                                "Quickly cancel and replace credit, debit and ATM cards if your wallet is lost or stolen."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Mobile App
                                            {PopoverTrigger(
                                                "Mobile App",
                                                "Anywhere, anytime protection with all the key capabilities required to rapidly access personal identity protection information from your smartphone (iOS and Android)."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Password Manager
                                            {PopoverTrigger(
                                                "Password Manager",
                                                "Your first line of defense for protecting your personally identifiable information against identity crimes, our Password Manager is a must-have — giving you on-the-go access to manage your passwords in one secure easy-to-use location. You also have access to a password tool to test strength and generate strong passwords."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Online Identity Vault
                                            {PopoverTrigger(
                                                "Online Identity Vault",
                                                "A secure digital library for storage of confidential and personally identifiable documents and images, such as credit cards, financial account statements, passports, driver’s licenses, and medical records. Includes multi-layered encryption storage of monitored personal and financial information, including SSNs, birth dates, bank accounts, and much more."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Credit Freeze & Credit Report Fraud Assistance
                                            {PopoverTrigger(
                                                "Credit Freeze & Credit Report Fraud Assistance",
                                                "Dedicated ID Theft Protection specialists are available to help you navigate through initiating a credit freeze or disputing fraudulent activity on your credit report."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>

                                    <tr className="hidden-sm no-border">
                                        <td></td>
                                        <td className="compare-column-idf"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th className="text-left">
                                            <h4>
                                                <img role="option"
                                                    className="img-icon"
                                                    src={require("../../Assets/images/funnel/sales/recover-white-icon.png").default}
                                                    alt="Recover Icon"
                                                />
                                                Recover
                                            </h4>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Identity Theft Insurance $1 Million
                                            {PopoverTrigger(
                                                "Identity Theft Insurance $1 Million",
                                                "Recover out-of-pocket expenses and lost wages when your identity is stolen."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Fully Managed Restoration
                                            {PopoverTrigger(
                                                "Fully Managed Restoration",
                                                "Complete, comprehensive recovery services from Certified Protection Experts available 24/7. Specialists do not just assist you with identity restoration, they save you hundreds of hours by completing all the paperwork, making calls and doing all the heavy lifting to make sure your identity is restored."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>Victim Assistance Only</td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Toll Free Customer Service
                                            {PopoverTrigger(
                                                "Toll Free Customer Service",
                                                "Our experienced team of member service professionals are on call to answer your questions and provide support."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            100% of Calls Answered in the U.S.
                                            {PopoverTrigger(
                                                "100% of Calls Answered in the U.S.",
                                                "100% of all calls are answered in the United States by trained agents."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Whiteglove Family Restoration
                                            {PopoverTrigger(
                                                "Whiteglove Family Restoration",
                                                "Complete identity theft restoration services from U.S.-based Certified Protection Experts, available 24/7 for any family member of your household (includes parents, siblings, and children of the primary account holder). Specialists don’t only assist with identity restoration, they can save you hundreds of hours by completing paperwork, making calls, and doing the heavy lifting to help restore your identity to pre-theft status."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Deceased Family Member Fraud Remediation
                                            {PopoverTrigger(
                                                "Deceased Family Member Fraud Remediation",
                                                "Comprehensive recovery services to protect and restore the identity of your loved one who is enrolled in a Family Plan at the time of their death, and later becomes a victim of identity theft."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    <tr className="hidden-sm no-border">
                                        <td></td>
                                        <td className="compare-column-idf"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th className="text-left">
                                            <h4>
                                                <img role="option"
                                                    className="img-icon"
                                                    src={require("../../Assets/images/funnel/sales/credit-white-icon.png").default}
                                                    alt="Credit Icon"
                                                />
                                                Credit
                                            </h4>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            3 Bureau Credit Monitoring
                                            {PopoverTrigger(
                                                "3 Bureau Credit Monitoring",
                                                "Spot fraud quickly with daily monitoring of your credit report and alerts you if key changes are detected."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            3 Bureau Credit Reports
                                            {PopoverTrigger("3 Bureau Credit Reports", "Instant online access to your credit report.")}
                                        </td>
                                        <td className="compare-column-idf">Every 3 months</td>
                                        <td>Monthly</td>
                                        <td>Only 1/year</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            3 Bureau Credit Scores
                                            {PopoverTrigger(
                                                "3 Bureau Credit Scores",
                                                "Instant online access to your credit scores that lenders look at when making loan decisions."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">Every 3 months</td>
                                        <td>Monthly</td>
                                        <td>Only 1/year</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">
                                            Credit Score Tracker
                                            {PopoverTrigger("Credit Score Tracker", "Track your credit scores over time with a month-after-month graph.")}
                                        </td>
                                        <td className="compare-column-idf">Monthly</td>
                                        <td>Monthly</td>
                                        <td>Monthly</td>
                                    </tr>
                                    <tr className="no-border-xs">
                                        <td className="text-left">
                                            Credit Score Simulator
                                            {PopoverTrigger(
                                                "Credit Score Simulator",
                                                "With our credit score simulator you can explore how several financial decisions may impact your credit. This tool will help you experiment with different credit balances, credit card payments, balance transfers and more."
                                            )}
                                        </td>
                                        <td className="compare-column-idf">
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td>
                                            <i className="fa fa-circle" style={{ color: "#DB5148" }}></i>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr className="hidden-sm no-border">
                                        <td></td>
                                        <td className="compare-column-idf"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="no-border">
                                        <td className="text-left"></td>
                                        <td className="compare-column-idf">
                                            <p>
                                                <button className="btn-default btn-primary sign-me-up" onClick={routeToOfferPage} type="button">
                                                    <span>SIGN ME UP</span>
                                                </button>
                                            </p>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div id="testimonialSection" className="container-fluid sales-landing-section">
                    <Testimonial />
                </div>
            </div>
        </>
    );
}

export default HowWeCompare;
